<template>
    <Card>
        <div>
            <div v-if="allowedUserRoles && allowedUserRoles.length">
                <div class="my-3">Select Role</div>
                <div style="max-width: 300px">
                    <SelectDropdown
                        :id="`form-subject`"
                        :options="allowedUserRoles.map((item) => ({ id: item.id, title: item.name }))"
                        :value="selectedUserRoleId"
                        @change="selectedUserRoleId = $event"
                    />
                    <!-- <Button @click="handleInitPermissions">Load Permissions</Button> -->
                </div>
            </div>

                            <div class="my-3">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                        <div class="">
                            <strong style="font-size: 1.25rem;">Permissions</strong>
                        </div>
                        <div class="d-flex items-center" style="gap: 15px">
                            <Button v-if="allowSelect" @click="updatePermissions" :disabled="saving">{{
                                saving ? "Please wait..." : "Update Permissions"
                            }}</Button>
                        </div>
                    </div>
                    <div class="mb-4">
                        <TabContainer @change="handleChangeTab" :tabs="permissionsGroupedTabs" :selectedTab="selectedTab" />
                    </div>
                    <div class="permission-sections">
                        <div v-for="permissionsGroupVal of permissionsGrouped" :key="permissionsGroupVal.id">
                            <div v-if="selectedTab && selectedTab.name == permissionsGroupVal.id">
                                <!-- Control Bar -->
                                <div class="permission-controls d-flex justify-content-between align-items-center mb-4 p-3 bg-light rounded">
                                    <div class="d-flex align-items-center" style="gap: 15px">
                                        <button 
                                            @click="toggleAllCollapse"
                                            class="btn btn-outline-secondary btn-sm"
                                            type="button"
                                        >
                                            <i :class="['fas', allCollapsed ? 'fa-plus' : 'fa-minus', 'me-1']"></i>
                                            {{ allCollapsed ? 'Expand All' : 'Collapse All' }}
                                        </button>
                                        <div class="text-muted small">
                                            {{ permissionsGroupVal.groups.length }} permission categories
                                            • {{ getTotalPermissionsCount(permissionsGroupVal) }} total permissions
                                            • {{ getSelectedPermissionsCount(permissionsGroupVal) }} selected
                                        </div>
                                    </div>
                                    <label class="form-check-label d-flex align-items-center">
                                        <input 
                                            :disabled="!allowSelect" 
                                            :value="1" 
                                            type="checkbox" 
                                            @change="selectAllPermissions"
                                            class="form-check-input me-2"
                                        /> 
                                        <strong>Select All Permissions</strong>
                                    </label>
                                </div>
                                
                                <!-- Permission Groups Grid -->
                                <div class="row g-3">
                                    <div class="col-lg-6 col-md-12" v-for="permissionsGroup of permissionsGroupVal.groups" :key="permissionsGroup.id">
                                        <PermissionEditorBlock
                                            ref="permissionBlocks"
                                            :allowSelect="allowSelect"
                                            :selectedPermissionIds="selectedPermissionIds"
                                            :permissionsGroup="permissionsGroup"
                                            @handlePermissionAdd="handlePermissionEditorBlockAdd"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                <div class="text-end">
                    <Button @click="updatePermissions">{{ saving ? "Please wait..." : "Update Permissions" }}</Button>
                </div>
            </div>
        </div>
    </Card>
</template>

<script>
import { http } from "@/utils/http"
import CrudIndex from "@/components/crud/index.vue"
import { mapActions, mapState } from "vuex"
import SelectDropdown from "../../components/crud/SelectDropdown.vue"
import Button from "../../components/UI/Button.vue"
import Card from "../../components/UI/Card.vue"
import TabContainer from "../../components/UI/TabContainer.vue"
import PermissionEditorBlock from "../../components/permission/PermissionEditorBlock.vue"

export default {
    data() {
        return {
            loading: false,
            saving: false,
            selectedUserRoleId: "",
            allowSelect: false,
            selectedPermissionIdGroups: {},
            selectedPermissionIds: [],
            selectedTab: null,
            allowUpdateSelectedPermissions: true,
            permissionInitialized: false,
            allCollapsed: false, // Track collapse state for all permission blocks
        }
    },
    props: { videoId: { type: String, default: "" } },
    components: { PermissionEditorBlock, Card, Button, SelectDropdown, CrudIndex, TabContainer },
    async mounted() {
        this.loading = false

        await this.initRoles()
        // setTimeout(async () => {
        //     try {
        //         console.log("amounted init roles")

        //         this.selectedUserRoleId = this.$route.query.role_id || (this.allowedUserRoles[0] ? this.allowedUserRoles[0].id : "")

        //         console.log("initPermissions from mounted", this.selectedUserRoleId)
        //         this.initPermissions(this.selectedUserRoleId)
        //     } catch (err) {
        //         console.log("error in initializing permission editor mounting", err)
        //     }
        // }, 1000)
        this.selectedUserRoleId = this.$route.query.role_id || (this.allowedUserRoles[0] ? this.allowedUserRoles[0].id : "")
        this.setData({
            pageTitle: "Permission Editor",
        })
    },
    methods: {
        ...mapActions("permission", ["initRoles", "initPermissions"]),
        ...mapActions("misc", ["setData"]),
        checkAllPermissions() {},
        handlePermissionEditorBlockAdd($event) {
            console.log("$event", $event)
            this.handlePermissionAdd($event.id, $event.forceRemove)
        },
        /**
         * Toggle collapse/expand all permission blocks
         */
        toggleAllCollapse() {
            this.allCollapsed = !this.allCollapsed
            
            // Access all permission block components and toggle their collapse state
            this.$nextTick(() => {
                if (this.$refs.permissionBlocks) {
                    this.$refs.permissionBlocks.forEach(block => {
                        block.isCollapsed = this.allCollapsed
                    })
                }
            })
        },
        /**
         * Get total count of permissions in a group
         */
        getTotalPermissionsCount(permissionsGroupVal) {
            return permissionsGroupVal.groups.reduce((total, group) => {
                return total + (group.permissions ? group.permissions.length : 0)
            }, 0)
        },
        /**
         * Get count of selected permissions in a group
         */
        getSelectedPermissionsCount(permissionsGroupVal) {
            let count = 0
            permissionsGroupVal.groups.forEach(group => {
                if (group.permissions) {
                    group.permissions.forEach(permission => {
                        if (this.selectedPermissionIds.includes(permission.id)) {
                            count++
                        }
                    })
                }
            })
            return count
        },
        async updatePermissions() {
            if (this.saving) return
            try {
                this.saving = true
                const res = await http.patch("/permissions", {
                    permissionIds: this.selectedPermissionIds,
                    role_id: this.selectedUserRoleId,
                })
                this.$toast.success("Permission updated successfully!")
                window.location.href = `/permissions/editor?role_id=${this.selectedUserRoleId}`
            } catch (err) {
                console.log("error in updating permissions", err)
            }
            this.saving = false
        },
        handleChangeTab(e) {
            this.selectedTab = e
        },
        handlePermissionAdd(pid, forceRemove = false) {
            console.log("handlePermissionAdd", pid, forceRemove)
            if (this.selectedPermissionIds.includes(pid) || forceRemove) {
                this.selectedPermissionIds = this.selectedPermissionIds.filter((item) => item != pid)
            } else {
                this.selectedPermissionIds.push(pid)
            }
        },
        async handleInitPermissions() {
            this.loading = true
            try {
                await this.initPermissions(this.selectedUserRoleId)
            } catch (err) {}
            this.loading = false
        },
        selectAllPermissions(event) {
            const val = event.target.checked
            console.log(val)
            if (val) {
                let permissionIds = []
                for (let permissionsGroupVal of this.permissionsGrouped) {
                    for (let permissionsGroup of permissionsGroupVal.groups) {
                        if (this.selectedTab.name == permissionsGroupVal.name) {
                            const ids = permissionsGroup.permissions.map((item) => item.id)
                            permissionIds.push(...ids)
                        }
                    }
                }
                this.selectedPermissionIdGroups[this.selectedTab.name] = permissionIds
            } else {
                this.selectedPermissionIdGroups[this.selectedTab.name] = []
            }

            this.selectedPermissionIds = []

            for (let key in this.selectedPermissionIdGroups) {
                const val = this.selectedPermissionIdGroups[key]
                if (val) {
                    this.selectedPermissionIds = [...this.selectedPermissionIds, ...val]
                }
            }
        },
    },
    computed: {
        ...mapState("permission", ["userRoles", "permissionsGrouped", "allowedPermissionIds"]),
        allowedUserRoles() {
            // return this.userRoles.filter((item) => !item.name.toLowerCase().includes("admin"))
            return this.userRoles
        },
        permissionsGroupedTabs() {
            return this.permissionsGrouped.map((item) => ({ name: item.name, value: item.name }))
        },
    },
    watch: {
        $route(e) {
            this.selectedUserRoleId = this.$route.query.role_id
        },
        permissionsGroupedTabs(e) {
            if (!this.selectedTab) {
                this.selectedTab = e[0]
            }
        },
        selectedUserRoleId(e) {
            const userRole = this.userRoles.find((item) => item.id == e)
            if (userRole && userRole.name.includes("Superadmin")) {
                let permissionIds = []
                for (let permissionsGroupVal of this.permissionsGrouped) {
                    for (let permissionsGroup of permissionsGroupVal.groups) {
                        const ids = permissionsGroup.permissions.map((item) => item.id)
                        permissionIds.push(...ids)
                    }
                }
                this.selectedPermissionIds = permissionIds
                this.allowSelect = false
            } else {
                this.allowSelect = true
                this.initPermissions(e)
            }
        },
        allowedPermissionIds(e) {
            this.selectedPermissionIds = e
        },
        userRoles(e) {
            if (e && e.length) {
                this.selectedUserRoleId = this.allowedUserRoles && this.allowedUserRoles[0] ? this.allowedUserRoles[0].id : ""
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";
.selected-checkbox-label {
    font-weight: bold;
}

/* Permission Editor Page Styling */
.permission-sections {
    min-height: 400px;
}

.permission-controls {
    background: $lightCardBg;
    border: 1px solid $lightBorderColor;
    box-shadow: $cardShadow;
    border-radius: $cardRadius;
}

.permission-controls .btn {
    transition: all 0.2s ease;
}

.permission-controls .btn:hover {
    transform: translateY(-1px);
    box-shadow: $cardShadowHover;
}

.form-check-label {
    cursor: pointer;
    user-select: none;
}

.form-check-input {
    cursor: pointer;
}

/* Responsive grid improvements */
@media (min-width: 1200px) {
    .col-lg-6 {
        flex: 0 0 auto;
        width: 50%;
    }
}

@media (max-width: 991.98px) {
    .col-md-12 {
        width: 100%;
    }
    
    .permission-controls {
        flex-direction: column;
        gap: 1rem;
        align-items: stretch !important;
    }
    
    .permission-controls > div {
        justify-content: center;
    }
}

/* Improved spacing */
.row.g-3 > * {
    padding-left: $tableCellPaddingX;
    padding-right: $tableCellPaddingX;
    margin-bottom: $sectionGap;
}

/* Better visual hierarchy */
.permission-sections .row {
    margin-left: -$tableCellPaddingX;
    margin-right: -$tableCellPaddingX;
}

/* Loading and saving states */
.btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* Card hover effects are now handled at component level */
</style>
